import Vue from 'vue'
import Router from 'vue-router'


import Info from './views/Info.vue'
import AllMedia from './views/AllMedia.vue'
import ImageSlider from './views/ImageSlider.vue'
import ConservatoryPano from './views/ConservatoryPano.vue'
import ConservatoryReveal from './views/ConservatoryReveal.vue'

/* eslint-disable */
import Background1 from './assets/backgrounds/1.jpg'
import Background2 from './assets/backgrounds/2.jpg'
import Background3 from './assets/backgrounds/3.jpg'
import Background4 from './assets/backgrounds/4.jpg'
import Background5 from './assets/backgrounds/5.jpg'
import Background6 from './assets/backgrounds/6.jpg'
import Background7 from './assets/backgrounds/7.jpg'
import Background8 from './assets/backgrounds/8.jpg'
import Background9 from './assets/backgrounds/9.jpg'
import Background10 from './assets/backgrounds/10.jpg'
import Background11 from './assets/backgrounds/11.jpg'
import Background12 from './assets/backgrounds/12.jpg'
/* eslint-enable */

Vue.use(Router)

function addBackLink(route, link) {
  return {
    ...route.params,
    backLink: link
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [

    /**
     * Below, Conservatory routes
     */
    {
      path: '/',
      name: 'conservatory',
      component: Info,
      props: {
        title: '',
        page: 'info',
        routeName: 'conservatory-swipe',
        surroundImage: Background12,
        transparent: true,
        backLink: process.env.VUE_APP_EXPERIENCE_ROOT,
        compile: true
      }
    },
    {
      path: '/swipe',
      name: 'conservatory-swipe',
      component: Info,
      props: {
        page: 'reveal',
        routeName: 'conservatory-explore',
        surroundImage: Background1,
        transparent: true,
        backLink: {
          name: 'conservatory'
        }
      }
    },
    {
      path: '/explore',
      name: 'conservatory-explore',
      component: ConservatoryReveal,
      props: {
        backLink: {
          name: 'conservatory'
        }
      }
    },
    {
      path: '/explore/pano',
      name: 'conservatory-explore-pano',
      component: ConservatoryPano,
      props: {
        showPano: true,
        backLink: {
          name: 'conservatory-explore'
        }
      }
    },
    {
      path: '/help',
      name: 'conservatory-help',
      component: Info,
      props: {
        page: 'help'
      }
    },
    {
      path: '/help/credits',
      name: 'conservatory-credits',
      component: Info,
      props: {
        page: 'credits',
        surroundImage: Background11,
        backLink: {
          name: 'conservatory-help'
        }
      }
    },
    {
      path: '/view/:exhibitslug',
      name: 'conservatory-view',
      component: AllMedia,
      props: (route) => addBackLink(route, {
        name: 'conservatory-explore-pano'
      }),
    },
    {
      path: '/view/:exhibitslug/photos/:slide?',
      name: 'conservatory-photo-slider',
      component: ImageSlider,
      props: (route) => addBackLink(route, {
        name: 'conservatory-view',
        params: {
          exhibitslug: route.params.exhibitslug
        }
      })
    },

    {
      path: '/extra/:exhibitslug',
      name: 'conservatory-extra',
      component: AllMedia,
      props: (route) => addBackLink(route, {
        name: 'conservatory'
      }),
    },
    {
      path: '/extra/:exhibitslug/photos/:slide?',
      name: 'conservatory-extra-photo-slider',
      component: ImageSlider,
      props: (route) => addBackLink(route, {
        name: 'conservatory-extra',
        params: {
          exhibitslug: route.params.exhibitslug
        }
      })
    },

  ]
})
